import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGlassWater: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGlassWater"><Path fillRule="evenodd" clipRule="evenodd" d="M17.8828 21H6.11719L3.86719 3H20.1328L17.8828 21ZM6.60449 8.77832C8.57686 8.32533 10.5009 8.70187 12.1846 9.01758C14.1081 9.37826 15.7452 9.66398 17.3457 9.16699L17.8672 5H6.13281L6.60449 8.77832Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGlassWater;
